import * as tslib_1 from "tslib";
import { ChangeDetectorRef, EventEmitter, ViewContainerRef } from '@angular/core';
import { first } from 'rxjs/internal/operators/first';
import { ESRI } from '../../esri-loader-util';
import { InputConverter } from '../../inputConverter';
import { GisToolsService } from '../../services/gis-tools.service';
import { BaseComponent } from '../base.component';
import UserSettingsConfiguration, { UserSettingsConfigurationArrayConverter } from './user-settings.config';
var Extent;
var UserSettingsComponent = /** @class */ (function (_super) {
    tslib_1.__extends(UserSettingsComponent, _super);
    function UserSettingsComponent(authService, UserSettingsService, changeDetectorRef, gisToolsService, _vcr) {
        var _this = _super.call(this, _vcr, true) || this;
        _this.authService = authService;
        _this.UserSettingsService = UserSettingsService;
        _this.changeDetectorRef = changeDetectorRef;
        _this.gisToolsService = gisToolsService;
        _this.userSettings = {
            districts: { value: [] },
            counties: { value: [] }
        };
        _this._active = false;
        _this.activeChange = new EventEmitter();
        _this.settingsChange = new EventEmitter();
        _this.allDistricts = [];
        _this.allCounties = [];
        _this.disabledSelects = {};
        _this._loaded = false;
        _this.registerWithMcScope();
        // Defaults
        if (!_this.userSettingsConfigs) {
            _this.userSettingsConfigs = [];
            _this.userSettingsConfigs.push(new UserSettingsConfiguration({
                name: 'districts',
                label: 'Districts',
                type: 'districts',
                isSelect: true
            }));
            _this.userSettingsConfigs.push(new UserSettingsConfiguration({
                name: 'counties',
                label: 'Default Counties',
                type: 'counties',
                isSelect: true
            }));
            _this.userSettingsConfigs.push(new UserSettingsConfiguration({
                name: 'extent',
                label: 'Extent',
                type: 'extent',
                items: [
                    { name: 'default', label: 'Default Extent', value: null }
                ]
            }));
            /*this.userSettingsConfigs.push(new UserSettingsConfiguration({
                name: 'map-options',
                label: 'Map Options',
                type: 'check-list',
                items: [
                    { name: 'promptBeforeReplace', label: 'Prompt before replacing map', value: false },
                    { name: 'preserveExtent', label: 'Preserve extent on map change', value: false },
                    { name: 'zoomAfterFiltering', label: 'Zoom to layer after filtering', value: false }//,
                    { name: 'displayScalebar', label: 'Display scalebar on map', value: true }
                ]
            }));*/
        }
        return _this;
    }
    Object.defineProperty(UserSettingsComponent.prototype, "active", {
        get: function () { return this._active; },
        set: function (value) {
            this._active = value;
            value ? this.activate() : this.deactivate();
            this.activeChange.emit(value);
        },
        enumerable: true,
        configurable: true
    });
    UserSettingsComponent.prototype.activate = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ESRI.Extent];
                    case 1:
                        Extent = _a.sent();
                        if (!this.userSubscriber) {
                            this.userSubscriber = this.authService.GetCurrentUser().subscribe(function (user) {
                                if (user && user.id) {
                                    _this.userEmail = user.emailAddress;
                                    _this.loadUserSettings();
                                }
                            });
                        }
                        if (!this.userSettingsSubscriber) {
                            this.userSettingsSubscriber = this.UserSettingsService.userSettingsChange.subscribe(function (setting) {
                                if (setting.settingName === 'userSettings') {
                                    _this.convertSettingsOnLoad(setting.value);
                                    _this.userSettings = setting.value;
                                    _this.settingsChange.emit(setting.value);
                                }
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    UserSettingsComponent.prototype.convertSettingsForSave = function (userSettings) {
        var e_1, _a;
        var convertedSettings = {};
        try {
            for (var _b = tslib_1.__values(Object.keys(userSettings)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var setting = _c.value;
                if (Array.isArray(userSettings[setting].value)) {
                    convertedSettings[setting] = tslib_1.__spread(userSettings[setting].value);
                }
                else {
                    convertedSettings[setting] = tslib_1.__assign({}, userSettings[setting]);
                    delete convertedSettings[setting].name;
                }
                if (setting === 'extent' && convertedSettings[setting].default) {
                    convertedSettings[setting] = { default: convertedSettings[setting].default.toJSON() };
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return convertedSettings;
    };
    UserSettingsComponent.prototype.convertSettingsOnLoad = function (userSettings) {
        var e_2, _a;
        var _loop_1 = function (settingConfig) {
            var userSetting = {
                name: settingConfig.name,
                value: userSettings[settingConfig.name]
            };
            switch (settingConfig.type) {
                case 'check-list':
                case 'extent':
                    settingConfig.items.forEach(function (item) {
                        userSetting[item.name] = item.value;
                    });
                    break;
                case 'counties':
                case 'districts':
                    userSetting.value = userSetting.value || [];
                    break;
                /* tslint:disable-next-line:switch-default */
            }
            if (settingConfig.type === 'extent') {
                if (userSetting.value && userSetting.value.default) {
                    userSetting.default = Extent.fromJSON(userSetting.value.default);
                }
                delete userSetting.value;
            }
            else if (Array.isArray(userSetting.value)) {
                userSetting.value = tslib_1.__spread(userSetting.value);
            }
            else {
                userSetting.value = tslib_1.__assign({}, userSetting.value);
            }
            userSettings[settingConfig.name] = userSetting;
        };
        try {
            for (var _b = tslib_1.__values(this.userSettingsConfigs), _c = _b.next(); !_c.done; _c = _b.next()) {
                var settingConfig = _c.value;
                _loop_1(settingConfig);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    /**
     * Make the tool inactive/hidden.
     */
    UserSettingsComponent.prototype.deactivate = function () {
        if (this.userSubscriber) {
            this.userSubscriber.unsubscribe();
            this.userSubscriber = undefined;
        }
        if (this.userSettingsSubscriber) {
            this.userSettingsSubscriber.unsubscribe();
            this.userSettingsSubscriber = undefined;
        }
        this._loaded = false;
    };
    UserSettingsComponent.prototype.loadUserSettings = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b, districtSetting, _c, countySetting;
            var _this = this;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!!this._loaded) return [3 /*break*/, 5];
                        _a = this;
                        return [4 /*yield*/, this.setupMapViewRef(this.mapView)];
                    case 1:
                        _a.mapRef = _d.sent();
                        return [4 /*yield*/, new Promise(function (resolve, _reject) {
                                _this.UserSettingsService.GetSettingValue('userSettings', _this.appName, _this.userEmail).pipe(first()).subscribe(function (results) {
                                    if (results) {
                                        _this.userSettings = results;
                                        _this.convertSettingsOnLoad(_this.userSettings);
                                    }
                                    resolve();
                                });
                            })];
                    case 2:
                        _d.sent();
                        _b = this;
                        return [4 /*yield*/, this.gisToolsService.getAllDistricts('districtNumber,counties{countyCode}')];
                    case 3:
                        _b.allDistricts = _d.sent();
                        districtSetting = this.userSettingsConfigs.find(function (s) { return s.name === 'districts'; });
                        districtSetting.items = this.getDistrictItems();
                        _c = this;
                        return [4 /*yield*/, this.gisToolsService.getAllCounties('countyCode,name,districtNumber')];
                    case 4:
                        _c.allCounties = _d.sent();
                        countySetting = this.userSettingsConfigs.find(function (s) { return s.name === 'counties'; });
                        if (this.userSettings.districts.value && this.userSettings.districts.value.length) {
                            countySetting.items = this.getCountyItems(this.userSettings.districts.value.map(function (v) { return v.replace('district-', ''); }));
                        }
                        else {
                            countySetting.items = this.getCountyItems();
                        }
                        this._loaded = true;
                        this.settingsChange.emit(this.userSettings);
                        this.changeDetectorRef.detectChanges();
                        _d.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    UserSettingsComponent.prototype.getDistrictItems = function () {
        return this.allDistricts.map(function (district) { return ({
            name: "district-" + district.districtNumber,
            label: "District " + district.districtNumber,
            value: district.districtNumber
        }); });
    };
    UserSettingsComponent.prototype.getCountyItems = function (selectedDistricts) {
        var availableCounties = this.allCounties;
        if (selectedDistricts !== undefined && selectedDistricts.length) {
            var districts_1 = this.allDistricts.filter(function (dis) { return selectedDistricts.includes(dis.districtNumber); });
            availableCounties = availableCounties.filter(function (cty) { return districts_1.map(function (dis) { return dis.counties.map(function (c) { return c.countyCode; }); }).flat().includes(cty.countyCode); });
        }
        return availableCounties.map(function (county) { return ({
            name: "county-" + county.countyCode,
            label: county.name,
            value: county.countyCode
        }); });
    };
    UserSettingsComponent.prototype.isSelect = function (type) {
        return (type === 'select-list' || type === 'districts' || type === 'counties');
    };
    UserSettingsComponent.prototype.onSettingChange = function (_value, setting) {
        // If selecting a district, limit the counties
        if (setting === 'districts') {
            var countySetting_1 = this.getCountySetting();
            if (countySetting_1) {
                countySetting_1.items = this.getCountyItemsForSelectedDistricts();
                this.userSettings.counties.value = this.userSettings.counties.value.filter(function (v) { return countySetting_1.items.map(function (i) { return i.name; }).includes(v); });
            }
        }
        this.settingsChange.emit(this.userSettings);
        this.changeDetectorRef.detectChanges();
    };
    UserSettingsComponent.prototype.getDistrictSetting = function () {
        return this.userSettingsConfigs.find(function (s) { return s.name === 'districts'; });
    };
    UserSettingsComponent.prototype.getCountySetting = function () {
        return this.userSettingsConfigs.find(function (s) { return s.name === 'counties'; });
    };
    UserSettingsComponent.prototype.getCountyItemsForSelectedDistricts = function () {
        var retVal = null;
        var districtSetting = this.getDistrictSetting();
        var districtValues = this.userSettings[districtSetting.name].value;
        var countySetting = this.getCountySetting();
        if (countySetting) {
            retVal = this.getCountyItems(districtValues.map(function (v) { return v.replace('district-', ''); }));
        }
        return retVal;
    };
    UserSettingsComponent.prototype.setExtent = function (settingName, itemName) {
        this.userSettings[settingName][itemName] = this.mapRef.extent;
        this.changeDetectorRef.detectChanges();
    };
    UserSettingsComponent.prototype.clearExtent = function (settingName) {
        this.userSettings[settingName].default = null;
        this.changeDetectorRef.detectChanges();
    };
    UserSettingsComponent.prototype.checkboxChange = function (settingName, checkItemName) {
        this.userSettings[settingName][checkItemName] = !this.userSettings[settingName][checkItemName];
        this.changeDetectorRef.detectChanges();
    };
    UserSettingsComponent.prototype.saveSettings = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var countySettingConfig, districtSettingConfig, countySetting, districtSetting;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        countySettingConfig = this.getCountySetting();
                        districtSettingConfig = this.getDistrictSetting();
                        if (countySettingConfig && districtSettingConfig) {
                            countySetting = this.userSettings[countySettingConfig.name];
                            districtSetting = this.userSettings[districtSettingConfig.name];
                            if (countySetting && (!countySetting.value || !countySetting.value.length) && districtSetting && districtSetting.value && districtSetting.value.length) {
                                countySetting.value = this.getCountyItemsForSelectedDistricts().map(function (item) { return item.name; });
                            }
                        }
                        return [4 /*yield*/, this.UserSettingsService.SetSettingValue('userSettings', this.convertSettingsForSave(this.userSettings), this.userEmail, this.appName)];
                    case 1:
                        _a.sent();
                        this.activeChange.emit(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    UserSettingsComponent.prototype.cancel = function () {
        this.activeChange.emit(false);
    };
    UserSettingsComponent.prototype.getSettings = function () {
        return this.userSettings;
    };
    UserSettingsComponent.prototype.getSetting = function (settingName) {
        return this.userSettings[settingName] || null;
    };
    tslib_1.__decorate([
        InputConverter(UserSettingsConfigurationArrayConverter),
        tslib_1.__metadata("design:type", Array)
    ], UserSettingsComponent.prototype, "userSettingsConfigs", void 0);
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean),
        tslib_1.__metadata("design:paramtypes", [Boolean])
    ], UserSettingsComponent.prototype, "active", null);
    return UserSettingsComponent;
}(BaseComponent));
export { UserSettingsComponent };
